import React, { useState } from "react";
import BasicInfo from "./Registration/BasicInfo";
import ProfileInfo from "./Registration/ProfileInfo";
import ReligionDetail from "./Registration/ReligionDetail";
import AboutUser from "./Registration/AboutUser";
import PageCount from "../component/utils/PageCount";
import FooterTwo from "../component/FooterTwo";

function Profile() {
  const [step, setStep] = useState(1);

  const nextStep = () => setStep((prev) => Math.min(prev + 1, 4));
  const prevStep = () => setStep((prev) => Math.max(prev - 1, 1));

  return (
    <>


<BasicInfo />
<PageCount pageName = {"Edit Profile"}/>

<FooterTwo />
      {/* <div className="profile-form-wrapper">

        
        <div className="step-indicator">
          <div className={`step-box ${step >= 1 ? "active" : ""}`}>1</div>
          <div className={`step-line ${step >= 2 ? "active" : ""}`}></div>

          <div className={`step-box ${step >= 2 ? "active" : ""}`}>2</div>
          <div className={`step-line ${step >= 3 ? "active" : ""}`}></div>

          <div className={`step-box ${step >= 3 ? "active" : ""}`}>3</div>
          <div className={`step-line ${step >= 4 ? "active" : ""}`}></div>

          <div className={`step-box ${step >= 4 ? "active" : ""}`}>4</div>
        </div>

       
        <div className="step-content-box shadow-sm">
          {step === 1 && <BasicInfo />}
          {step === 2 && <ProfileInfo />}
          {step === 3 && <ReligionDetail />}
          {step === 4 && <AboutUser />}
        </div>

       
        <div className="step-navigation">
          {step > 1 && (
            <button className="btn btn-outline-secondary" onClick={prevStep}>
              Previous
            </button>
          )}

          {step < 4 ? (
            <button className="btn btn-theme" onClick={nextStep}>
              Next
            </button>
          ) : (
            <button className="btn btn-success">
              Submit Profile
            </button>
          )}
        </div>
      </div> */}
    </>
  );
}

export default Profile;
